import { ReactNode, createContext, useContext } from "react";
import { useFilterTransactionWaiver } from "./filter-transaction-waiver.hook";

const FilterTransactionWaiverContext = createContext(
  {} as ReturnType<typeof useFilterTransactionWaiver>
);
export function useFilterTransactionWaiverContext() {
  return useContext(FilterTransactionWaiverContext);
}

interface FilterTransactionWaiverProviderProps {
  children: ReactNode;
}
export function FilterTransactionWaiverProvider({
  children,
}: FilterTransactionWaiverProviderProps) {
  return (
    <FilterTransactionWaiverContext.Provider value={useFilterTransactionWaiver()}>
      {children}
    </FilterTransactionWaiverContext.Provider>
  );
}